const Cart = () => import('@/pages/cart/Cart.vue');

export default [{
  path: '/cart',
  name: 'cart',
  meta: {
    isLogin: true
  },
  component: Cart
}, ]